import {inject} from '@angular/core';
import {type CanActivateFn, Router} from '@angular/router';

export const authGuard: CanActivateFn = async (route, state) => {
  if (sessionStorage.getItem('email') && sessionStorage.getItem('token')) {
    return true;
  } else {
    const router = inject(Router);
    await router.navigate(['login']);
    return false;
  }
};
